/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: fuzE93KTc4ZKNBYf3LAfy
// Component: iKmOjRERju

import * as React from "react";

import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  Flex as Flex__,
  hasVariant,
  SingleBooleanChoiceArg,
  StrictProps,
  useDollarState,
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";

import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: fuzE93KTc4ZKNBYf3LAfy/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import "./plasmic_plasmic_kit_context_menu_indicator.css"; // plasmic-import: fuzE93KTc4ZKNBYf3LAfy/projectcss
import sty from "./PlasmicBoundingBoxHighlighter.module.css"; // plasmic-import: iKmOjRERju/css

createPlasmicElementProxy;

export type PlasmicBoundingBoxHighlighter__VariantMembers = {
  isRecording: "isRecording";
};
export type PlasmicBoundingBoxHighlighter__VariantsArgs = {
  isRecording?: SingleBooleanChoiceArg<"isRecording">;
};
type VariantPropType = keyof PlasmicBoundingBoxHighlighter__VariantsArgs;
export const PlasmicBoundingBoxHighlighter__VariantProps =
  new Array<VariantPropType>("isRecording");

export type PlasmicBoundingBoxHighlighter__ArgsType = {};
type ArgPropType = keyof PlasmicBoundingBoxHighlighter__ArgsType;
export const PlasmicBoundingBoxHighlighter__ArgProps = new Array<ArgPropType>();

export type PlasmicBoundingBoxHighlighter__OverridesType = {
  root?: Flex__<"div">;
  outerBorder?: Flex__<"div">;
  outerBorder2?: Flex__<"div">;
  innerBorder?: Flex__<"div">;
};

export interface DefaultBoundingBoxHighlighterProps {
  isRecording?: SingleBooleanChoiceArg<"isRecording">;
  className?: string;
}

const $$ = {};

function PlasmicBoundingBoxHighlighter__RenderFunc(props: {
  variants: PlasmicBoundingBoxHighlighter__VariantsArgs;
  args: PlasmicBoundingBoxHighlighter__ArgsType;
  overrides: PlasmicBoundingBoxHighlighter__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants,
  };

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const stateSpecs: Parameters<typeof useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "isRecording",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) =>
          $props.isRecording,
      },
    ],
    [$props, $ctx, $refs]
  );

  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $q: {},
    $refs,
  });

  const styleTokensClassNames = _useStyleTokens();

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        "all",
        "root_reset_fuzE93KTc4ZKNBYf3LAfy",
        "plasmic_default_styles",
        "plasmic_mixins",
        styleTokensClassNames,
        sty.root
      )}
    >
      <div
        data-plasmic-name={"outerBorder"}
        data-plasmic-override={overrides.outerBorder}
        className={classNames("all", sty.outerBorder)}
      />

      <div
        data-plasmic-name={"outerBorder2"}
        data-plasmic-override={overrides.outerBorder2}
        className={classNames("all", sty.outerBorder2, {
          [sty.outerBorder2isRecording]: hasVariant(
            $state,
            "isRecording",
            "isRecording"
          ),
        })}
      />

      <div
        data-plasmic-name={"innerBorder"}
        data-plasmic-override={overrides.innerBorder}
        className={classNames("all", sty.innerBorder)}
      />
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: ["root", "outerBorder", "outerBorder2", "innerBorder"],
  outerBorder: ["outerBorder"],
  outerBorder2: ["outerBorder2"],
  innerBorder: ["innerBorder"],
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  outerBorder: "div";
  outerBorder2: "div";
  innerBorder: "div";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicBoundingBoxHighlighter__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicBoundingBoxHighlighter__VariantsArgs;
    args?: PlasmicBoundingBoxHighlighter__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & // Specify variants directly as props
  Omit<PlasmicBoundingBoxHighlighter__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicBoundingBoxHighlighter__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicBoundingBoxHighlighter__ArgProps,
          internalVariantPropNames: PlasmicBoundingBoxHighlighter__VariantProps,
        }),
      [props, nodeName]
    );
    return PlasmicBoundingBoxHighlighter__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName,
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicBoundingBoxHighlighter";
  } else {
    func.displayName = `PlasmicBoundingBoxHighlighter.${nodeName}`;
  }
  return func;
}

export const PlasmicBoundingBoxHighlighter = Object.assign(
  // Top-level PlasmicBoundingBoxHighlighter renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    outerBorder: makeNodeComponent("outerBorder"),
    outerBorder2: makeNodeComponent("outerBorder2"),
    innerBorder: makeNodeComponent("innerBorder"),

    // Metadata about props expected for PlasmicBoundingBoxHighlighter
    internalVariantProps: PlasmicBoundingBoxHighlighter__VariantProps,
    internalArgProps: PlasmicBoundingBoxHighlighter__ArgProps,
  }
);

export default PlasmicBoundingBoxHighlighter;
/* prettier-ignore-end */
